import { getApiBase } from "_helpers";
import { cookieService } from "_services";

const baseRequest = (endpoint, body) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/admin/damagingpartyname/${endpoint}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`Error fetching ${endpoint}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const baseGetRequest = (endpoint, params = {}) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  // Build query string
  const queryParams = new URLSearchParams();
  if (jwtCookie) {
    queryParams.append("jwtCookie", encodeURI(cookieService.get("token")));
  }

  // Add other params
  Object.keys(params).forEach((key) => {
    queryParams.append(key, params[key]);
  });

  const queryString = queryParams.toString();

  return fetch(`${apiBase}/admin/damagingpartyname/${endpoint}?${queryString}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`Error fetching ${endpoint}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const baseDeleteRequest = (endpoint, body) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/admin/damagingpartyname/${endpoint}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`Error in ${endpoint}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const basePutRequest = (endpoint, body) => {
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/admin/damagingpartyname/${endpoint}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`Error in ${endpoint}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const searchAdminDamagingParties = (searchTerm) => baseGetRequest("search", { term: searchTerm });

const searchByClaimId = (claimId) => baseGetRequest("byclaim", { claimid: claimId });

const searchInClaims = (damagingName) => baseGetRequest("searchinclaims", { name: damagingName });

const searchInContacts = (name) => baseGetRequest("searchincontacts", { name: name });

const deleteDamagingParties = (ids) => baseDeleteRequest("delete", { ids });

const updateClaimNames = (ids, newName) => basePutRequest("updateclaims", { ids, newName });

const updateContactNames = (ids, newName) => basePutRequest("updatecontacts", { ids, newName });

export const damagingNameService = {
  searchAdminDamagingParties,
  searchByClaimId,
  searchInClaims,
  searchInContacts,
  deleteDamagingParties,
  updateClaimNames,
  updateContactNames,
};
